// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"aee11584","977":"a05dd363"}[chunkId] + ".chunk.js";
};